export default __webpack_public_path__ + "static/media/pfp1.ba7974ae.jpg";